import React, { useState, useEffect } from "react";
import { MdKeyboardArrowUp } from "react-icons/md";

const ScrollUpButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show or hide the button depending on scroll position
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll the page to the top when the button is clicked
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div className="scroll-up-button">
      {isVisible && (
        <div onClick={scrollToTop} className="scroll-to-top">
          <a
            id="scrollUp"
            // href="#top"
            style={{ position: "fixed", zIndex: 2147483647 }}
          >
            <MdKeyboardArrowUp size={30} />
          </a>
        </div>
      )}
    </div>
  );
};

export default ScrollUpButton;
